// extracted by mini-css-extract-plugin
export var col = "lesson-module--col--2745f";
export var icon = "lesson-module--icon--2d2e0";
export var item = "lesson-module--item--00b06";
export var lesson = "lesson-module--lesson--e3d81";